// Customer-facing referral hub API. Mirrors the Pydantic schemas
// in backend/app/routers/referrals.py — keep in sync.

import { apiFetch } from './client'

export interface ReferralMe {
  code: string
  friends_joined: number
  reward_earned_cents: number
  reward_per_referral_cents: number
  discount_rate_pct: number
  program_enabled: boolean
}

export const referralApi = {
  hubMe: () => apiFetch<ReferralMe>('/api/referrals/me'),
}
